export default "__VITE_ASSET__Cs$gY1dr__"